import { QRCode } from "react-qrcode-logo";
import { Box, Text } from "@chakra-ui/react";

const InvoiceQr = ({ address }) => {
  if (!address) {
    return (
      <Box textAlign="center" p={4}>
        <Text color="text.secondary">QR code will appear after selecting payment method</Text>
      </Box>
    );
  }

  return (
    <QRCode
      logoImage="https://ipscore.app/assets/img/logo.png"
      size={220}
      value={address}
      logoWidth={120}
      logoHeight={120}
    />
  );
};

export default InvoiceQr;
